import { z } from 'zod';
import { DataRoomStatus } from 'further-types/data-room';

export const schema = z.object({
  status: z.nativeEnum(DataRoomStatus),
  headline: z.string(),
  subheading: z.string(),
  contact: z.object({
    email: z.string(),
    image: z
      .object({
        uri: z.string(),
        objectKey: z.string(),
        fileName: z.string(),
      })
      .nullable(),
    name: z.string(),
    phone: z.string(),
  }),
  keyInformation: z.array(
    z.object({ fieldName: z.string(), value: z.string() }),
  ),
});

export type DataRoomFormData = z.infer<typeof schema>;

export const defaultData: DataRoomFormData = {
  status: DataRoomStatus.Inactive,
  headline: '',
  subheading: '',
  contact: {
    email: '',
    image: null,
    name: '',
    phone: '',
  },
  keyInformation: [{ fieldName: '', value: '' }],
};
